import { Component, computed, inject, input, OnInit, output, PLATFORM_ID, signal } from '@angular/core';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { ILineItems } from '../../../models/ILineItems';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faCartPlus, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { RouterModule } from "@angular/router";
import { isPlatformBrowser } from '@angular/common';

export enum ButtonState {
  AlreadyAdded,
  JustAdded,
  NotAdded,
}

@Component({
  selector: 'app-add-to-cart-button',
  imports: [
    FontAwesomeModule,
    RouterModule,
  ],
  templateUrl: './add-to-cart-button.component.html',
  styleUrl: './add-to-cart-button.component.scss'
})
export class AddToCartButtonComponent implements OnInit {
  public readonly auctionId = input.required<number>();
  public readonly lineItems = input.required<ILineItems[]>();
  public readonly checkIfAdded = input.required<boolean>();

  public readonly cartChangedSignal = output();

  private readonly cartService = inject(ShoppingCartService);
  private readonly platformId = inject(PLATFORM_ID);

  protected buttonState = signal(ButtonState.NotAdded);

  protected readonly icons = {
    faCartPlus: faCartPlus,
    faCheckCircle: faCheckCircle,
    faTimesCircle: faTimesCircle,
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.checkIfAdded() && this.cartService.isElementFullyInCart(this.auctionId(), this.lineItems())) {
        this.buttonState.set(ButtonState.AlreadyAdded);
      } else {
        this.buttonState.set(ButtonState.NotAdded);
      }
    }
  }

  protected isStateAlreadyAdded = computed(() => this.buttonState() == ButtonState.AlreadyAdded);
  protected isStateJustAdded = computed(() => this.buttonState() == ButtonState.JustAdded);
  protected isStateNotAdded = computed(() => this.buttonState() == ButtonState.NotAdded);

  protected addToCart = () => {
    this.lineItems().forEach(element => {
      this.cartService.addElementToCart(this.auctionId(), element);
    });
    this.buttonState.set(ButtonState.JustAdded);
    this.cartChangedSignal.emit();
  };
}
